import { sortsTextToArray } from "../PQMethod/sortsTextToArray";
import { sortsDisplayText } from "../dataUtilities/sortsDisplayText";

const uploadKocData = () => {
  const sorts = [
    "01Edelst   1 0-1-2 0 2 3-4 1 1 5 1-2-3 0-5-1-2-1-3 0-1 2 4 2 0-2 1 2 3 0-4-1 4 3-3",
    "02Larsen   3-1 0-2-1 1 0 0 0 1 0 2-3-2 1-2 0-1-3-4 4 2-1 1 3 2-1 1 3 4-2-4-3 5 2-5",
    "03Rubins   5-1-5-2-2 1 2-1 4 0 0-1 1-1 3-3-4-4 0-3 1-3 0 1 3 4 0 0 1 2 2-2-2 3 2-1",
    "04Werner  -1-2 0 1-1 2 2-2 3 3 2 4 3-3 1-2-3-5-1-2-4 2 0 4-1 0 0-1 1 5 0-4-3 1 1 0",
    "05Smith    5-2-1-2-3 4-1 0 3 3 2 1-1-4 1-4-1-2-2-3 0 0 0 3 4 0-3 2 1 2 1-5-1 0 2 1",
    "06Roseng   2-3 0 1-2 2 3-4 2 2-1 1 3-5-1-1 1-1-2-3 4-1-4 0 1 0 3 0 0 5-3-2 0 4 1-2",
    "07Berger   4 1-1-4-1 3 2 0 0 5-3 2 0-3 2-2-1-1-1-5-4-2 4 1 1 3-3 0 2 1 3-2 0-2 1 0",
    "08Barcus  -2-2-3-4-1 0 2 0 1 2 0 1 4-4-1-3-1-5 4-3 2 0 2 0 0 3 1 1 1 5-1-2-1 3 3-2",
    "09Linn     1 3-1-4-2 0 2-3 4 5 3 1-2-2-1-1-3 0-2-4 2 1 4 0-1 2-1 0 0 2 3 0-5 1 1-3",
    "10Pool     5-5 0-3 0 2 1 1 3 3-1 1-3-4 0-2 0-1-2-3-2-1 1-4 4 2-1 3 0 0 2-1 1 2 4-2",
    "11Himmel   2-3 2 1-2-3 2 0 3 4 1 0 3-1 0-4-2-3-2-2 0-4 1 4 3 0-1-1 1 1 2-5-1 5 0-1",
    "12Beinst   1-1-1-1-2 2 2-3 4 1 0 1 0-2 1-3 0-2 0-4 0-3-2 2 5 0-1 3 2 3 3-5-1 1 4-4",
    "13Pisare  -2 0 5 1 2 0 2-2-3 1-5-2 2-3-2 2 3 4-1-1-1 3 0 0-3-1 4-1 1 0-4-4 1 3 1 0",
    "14Maletz   3 1-4-2-2 4 0 2 3 3 2 0-1 1 4-2-3-1-1-4 0 1 0 5-5 1-1 0 2 1 2-3-2-1 0-3",
    "15Nakaji   3-1-2 0 1 3 1 2 4 2 0-1 2 0 1-5-1-4-4-3-3 0-2-2-2 5 1 0 0 4 1-1-1 3 2-3",
    "16Sicins   3-3-1 0 0 2 0-4 5 2-1-2-1-2 0 1 1-3-1-4-1 1 0-2 3 4 4 0 3 2 1-3-5 1 2-2",
    "17Kato     2-1-4-3 0 2-1 1 2 4 3 1-1 1 2-2 0 0-5-3-1 0-2 1 5 3-2-1 1 3 4-4-2 0 0-3",
    "18Lyle    -2 1 1 1 2 4 0-2 2 5 1 0 3-5 1-2-2-1-4-3-3 3-1 2-3 4-1 0 0 2 0-4-1 3 0-1",
    "19Lerg     0 1-1 0 0 3 0-4 3 5 1 1-1 0 2-3-1-3-1-2-2-3 2 1 1 2-5-4 4 2 3 0-2-2 4-1",
    "20Escarp   2-1 0 1 0 0-3-3-1 3-3 0 3-1 0-2-1-1 3-2 1 0 5 2 1 2-2 4 1 1-4-5 4-2 2-4",
    "21Rahl     5-1-1 2-4 1 1 0 4 1 1 0 0-2 0-3-3 0 0-3-1-1 1-5 4 2-2 2 3 3 2-4-2-2 3-1",
    "22Tanaka   0-5 3-4 0 2 3-2 1 2 0-4-2 0 1-3 1 1-3-3-1 0 2 0-1 3 1-2 5-1 4-1-1 4 2-2",
    "23Goyer    1 2 0 0-4 4 3-2 1 4 0-1-2 0-3-1 2-2 1-4 2-3-1-1 1 5-1 3 1 3 0-5-2 0 2-3",
    "24Uno     -3-1 1 2-1 0 0-1 4 2 2 0 3-2 2 1-1 0-3-4-3 1-5-2 0 5-2-1 4 1-2-4 1 3 3 0",
    "25Mestro   2-3 1-3 2 2 1 0-1 3-1-5-2-2-1-2 0 0-1-4 1 4 0-2-1 4 2 1 1 3-3-4 0 5 3 0",
    "26Kubin    1-5 1 2 3 3 2 3-3 1 1 0-3-4 1-2-1-4 2-3-2 2-1 0-2 0 4-1 0 5-1 0-1 4 0-2",
    "27Campea   4 2 2-1-3 2 0-2-2 0 1 3-1-1-4-2-1 0-5-3-2 2 4 1 3 1 3 0-1 1-3-4 0 1 0 5",
    "28McQuai   1 0-2-3-3 2-1-1 4 3 0 0-1 0 2-5-2-1 1-2-3-4 0 3 5 1 2 0 2 1 1-2-4 3 4-1",
    "29Barbic   1-1 5-4 2 4 2 1-2 1 0 0-5-4 3-1-2 3-3-3-1 0 1 0-1 2 1-3-1 4 0-2-2 2 3 0",
    "30Singh    0 2-1-2-2 5 2-4 2 0 3 4 1-3 0-1-1-2-1-5 3-2 0 1 3 1-1 0 2 4 0-3-3 1 1-4",
    "31Brown   -1 3 5 4-2 0 1 2-1 2 1 1 0-3 2-4-3-2-3-2 0 3-5 3 0 4-2 0 0 2-1-1 1-1 1-4",
    "32Dajani   0-3 3-4 4 1 1-1 3 2-2 0 0-3-1-2-2-1 0-5 2 1 1-1 2 4-1 0 1 5 3-4-3 2 0-2",
    "33Berlo    5 1-3-2 0 3 0-1 3 3-1-5 1-2-2-4 1-1 0-2 2-4 0-1 4 2-3 1 2 2 1-3 0 0 4-1",
    "34Koning   1 1-1 1 1 4 2-4 0 5-1 3 2-1-3 0 0-2-3-5-1 1-2-2 0 2 0 0 4 3-2-3-4 2 3-1",
    "35Lazars   2-3 2 4-4 0 1-3 4 3 0 0 0-5-2-4-1 1 0-3 2-1-2-2-1 3 1 0 2 1 5-1-1 1 3-2",
    "36Cherry   4-1-1-3-1 5 1 3 2 4 0 1 0 1-2-3-1-2-3-5 0 1 0 0 2 0-2 1 2 2-1-4-2 3 3-4",
    "37Noelle   1-1 4-3-1 0 1 0 2 0-5-1 0-3 3-2 0 1 5-2 0 1-2 4 3 2-2 2 3-1-1-4-4 2 1-3",
    "38WS1975   3 1-2 0-1 5 1-4 2 1 4 2 1-5 2-2-1-1 0-4 2-3-3-1 1 4-2 3-3 0 3-2 0 0 0-1",
  ];

  let sortsData = sortsTextToArray(sorts, 36, -5);
  let sortsDisplayText2 = sortsDisplayText(sortsData[1]);

  const data = {
    projectName: "KOC Demo",
    projectHistoryArray: ["KOC project loaded from demo data"],
    statements: [
      "ce-All information is imperfect                             01",
      "be-Methdlgy can dehumanize people and turn them into numbers02",
      "cd-Anything unknown at present will evntlly be known entrly 03",
      "ad-Scientists' road to knwldg more prfct than philosophers' 04",
      "bd-Reslts of proper scntfc experiments speak for themslvs   05",
      "ce-Information exchanged only within a play of tolerance    06",
      "ad-The scntst strives to delineate man, not just sketch him 07",
      "cd-Science separates the world from our perception of it    08",
      "be-Human error cannot be taken out of scientific observation09",
      "ce-The world shifts under our gaze, interacting with us ... 10",
      "ae-Who claims absolute knowledge opens the door to tragedy  11",
      "ce-Ragamuffin, barefoot irreverence important for students  12",
      "ad-A true scientist has an itch for absolute knowledge      13",
      "bd-Philosophers' road to knwldg more perfect than observtn  14",
      "be-Observations are still fuzzy and as uncertain as ever    15",
      "bd-Scientific methdlgy results in unimpeachable conclusions 16",
      "bd-Whenever instruments of sufficient precision are avlble..17",
      "bd-Fundamental units of world will not long evade our methds18",
      "bd-Certainty is achieved through observation, never infrnce 19",
      "cd-Physical scnce has shown to be the only avenue to knwldg 20",
      "be-One cannot xpct to find a better estimate than the avrge 21",
      "ad-Error not inextricbly bound up with the scntst's knwldg  22",
      "ae-Scientific knwldg is subjtv knwldg, scntst is respnsble  23",
      "ae-Sctst claiming absolute knwldg is arrogant and dogmatical24",
      "be-No event can be measured with certainty                  25",
      "be-Scntfc mthd tribute to wht we can know thgh bng fallible 26",
      "ad-One of scntsts' aim is exact picture of the material wrld27",
      "ae-The scientist expects the world to be inexact            28",
      "ce-New ideas in science amount to dffrnt views of reality   29",
      "ae-Would-be scntst: not to worship the known but to qustn it30",
      "ae-All jdgmnts product of indvdl scntst and at edge of error31",
      "cd-Where people argue and contradict science cannot exist   32",
      "ad-Scientist completes work by arrvng at a mathmticl formltn33",
      "cd-Science progresses step by step by eliminating error     34",
      "ce-Judgment is built into acts of recognition               35",
      "cd-Only in science can we be crtn that what we know is true 36",
    ],
    numQsorts: 38,
    numStatements: 36,
    multiplierArray: [
      0, 1, 2, 3, 4, 5, 6, 5, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    mainDataObject: sortsData[1],
    sortsDisplayText: sortsDisplayText2,
    respondentNames: sortsData[0],
    qSortPattern: [
      -5, -4, -4, -3, -3, -3, -2, -2, -2, -2, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0,
      0, 1, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 4, 4, 5,
    ],
    statementNumArray: [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    ],
  };
  return data;
};

export default uploadKocData;
